module.exports = __webpack_public_path__ + "img/qian-4.f6ccfa41.svg";